export default __webpack_public_path__ + "static/media/personalDocumentsCTAmob.a885db16.jpg";